import apiService from '@/modules/apis/apiService'
import { purchaseItemStore } from '@/store/purchase-item.store'
import { PurchaseItem } from '@/types/purchase.type'
import { getArtistLastPage } from '@/utils/artist-pathname'
import { useMutation } from '@tanstack/react-query'

const getDeliveryPurchaseItem = async () => {
  const response = await apiService.get('/api/v1/products/delivery-fee', {
    params: {
      eventKey: getArtistLastPage(),
    },
  })

  return response.data.result as PurchaseItem
}

export const useGetDeliveryPurchaseItemMutation = () => {
  return useMutation({
    mutationFn: getDeliveryPurchaseItem,
    onSuccess: (data) => {
      purchaseItemStore.getState().setDeliveryPurchaseItem(data)

      return data
    },
  })
}
